import { environment } from '../../../environments/environment';

import type { Environment } from '../../../environments/environment.types';

/**
 * Adaptateur de l'environnement BackStage vers le contrat attendu par le kit V3.
 *
 * Le contrat vient du Manager : il decrit une application OIDC multi-tenant avec
 * impression QZ Tray, ajusteur de plans et capture de diagnostics. BackStage n'a
 * rien de tout cela — il s'authentifie via MSAL / Azure AD et n'a qu'un seul
 * locataire. Plutot que de reecrire les cinq fichiers d'environnement de
 * BackStage pour satisfaire un contrat qui ne le decrit pas, on **traduit** ici :
 * les champs qui ont un sens sont repris, les autres sont neutralises.
 *
 * Seuls `showComponentsGallery` (barre de navigation) et `apiBaseUrl` sont
 * reellement lus par les composants du kit montes dans BackStage. Les champs
 * OIDC ne sont jamais consultes : l'authentification passe par `MsalModule`.
 */
export const ENVIRONNEMENT_BACKSTAGE: Environment = {
  production: environment.production,
  showComponentsGallery: environment.showComponentsGallery,
  apiBaseUrl: environment.backendUrl,

  // Outils de developpement du Manager, sans equivalent BackStage.
  enableDevTools: false,
  enablePlanTuner: false,
  enableDiagnosticsCapture: false,
  enableAiImprove: false,
  enableCustomFonts: false,

  // Impression billetterie : hors perimetre BackStage.
  useMockPrinting: true,
  qzTrayMinVersion: '0.0.0',

  // Variante `http` du contrat. Les champs OIDC sont inertes : c'est MSAL qui
  // authentifie, ils ne sont la que pour satisfaire le type.
  apiMode: 'http',
  oidcAuthority: '',
  oidcClientId: '',
  oidcScope: '',
  aparteBaseUrl: '',
  featureFlagsUrl: `${environment.backendUrl}feature-flags`,
};
